module.exports = __webpack_public_path__ + "static/media/ios-navigate.f739c271.svg";